import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AxiosPromise } from '../../../utils/axios.promise';
import { CommonConfig } from '../../../configs/config.common';
import ASpaceInBetweenAnother from '../../../shared/ASpaceInBetweenAnother/a.space.inbetween.another.vue';
import * as T_T from 'cryface';
import * as _ from 'lodash';
import { hybridShareCommunityAgeOptions } from './data/options.age';
// @ts-ignore
import ECharts from 'vue-echarts';
// @ts-ignore
import rifoTheme from '../../../vue-plugin/echarts/theme.json';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import { hybridShareCommunityGenderOptions } from './data/options.gender';
import { hybridShareCommunityTongueOptions } from './data/options.tongue';
import { hybridShareCommunityMaritalOptions } from './data/options.marital';
import { hybridShareCommunityEduOptions } from './data/options.education';
import { hybridShareCommunityCitizensOptions } from './data/options.citizenship';
import { hybridShareCommunityWorklocationOptions } from './data/options.worklocation';
import { hybridShareCommunityOwnershipOptions } from './data/options.ownersihp';
import { hybridShareCommunityEmploymentOptions } from './data/options.employment';
import { hybridShareCommunityIncomeOptions } from './data/options.income';
import { hybridShareCommunityHouseholdSizeOptions } from './data/options.household.size';
import { hybridShareCommunityConstructionOptions } from './data/options.construction';
import { hybridShareWorkTransOptions } from './data/options.worktrans';
import { hybridShareCommunityDwellingsOptions } from './data/options.dwellings';
import { HybridShareCommunityI18n } from './hybrid.share.community.i18n';
import { GoogleTranslate } from '../../../services/google.translate';
import { I18N } from '../../../utils/i18n/i18n';

ECharts.registerTheme('rifo', rifoTheme);
@Component({
  components: {
    ASpaceInBetweenAnother,
    ECharts,
  },
})
export default class HybridShareCommunityPage extends Vue {
  public data: string = '';
  public neighbourhoodData: any = null;
  public generalDataOne: any = null;
  public generalDataTwo: any = null;
  public ageData: any = null;
  public ageOptions: any = null;
  public tongueData: any = null;
  public tongueOptions: any = null;
  public educationData: any = null;
  public educationOptions: any = null;
  public maritalData: any = null;
  public maritalOptions: any = null;
  public incomeData: any = null;
  public incomeOptions: any = null;
  public householdSizeData: any = null;
  public householdSizeOptions: any = null;
  public constructionData: any = null;
  public constructionOptions: any = null;
  public citizenshipData: any = null;
  public citizenshipOptions: any = null;
  public genderData: any = null;
  public genderOptions: any = null;
  public worklocationData: any = null;
  public worklocationOptions: any = null;
  public workTransportationData: any = null;
  public workTransportationOptions: any = null;
  public dwellingData: any = null;
  public dwellingOptions: any = null;
  public employmentData: any = null;
  public employmentOptions: any = null;
  public ownerData: any = null;
  public ownerOptions: any = null;
  public configs = new CommonConfig();
  public googleTransService = new GoogleTranslate();

  public tags: string[] = [];

  @Watch('data', { immediate: true, deep: true })
  public onDataInput(val: any, oldVal: any) {}

  public async created() {}

  public async mounted() {
    const apiHost = this.configs.analysisService;
    const lat = this.$route.query['Latitude'];
    const lng = this.$route.query['Longitude'];
    this.$store.commit('appStartFetching');
    if (T_T.simpleDetect(lat) && T_T.simpleDetect(lng)) {
      const fetched = await AxiosPromise.get(
        `${apiHost}/community/epic?Latitude=${lat}&Longitude=${lng}`
      );
      if (fetched.code === 200) {
        try {
          const formatFetchedData = this.keysToCamel(fetched.data);
          console.log('=========== TEST Request Success');
          // data
          this.ageData = T_T.simpleDetect(formatFetchedData['Age'])
            ? formatFetchedData['Age']
            : null;
          this.tongueData = T_T.simpleDetect(formatFetchedData['MotherTongue'])
            ? formatFetchedData['MotherTongue']
            : null;
          this.maritalData = T_T.simpleDetect(
            formatFetchedData['MaritalStatus']
          )
            ? formatFetchedData['MaritalStatus']
            : null;
          this.incomeData = T_T.simpleDetect(formatFetchedData['Income'])
            ? formatFetchedData['Income']
            : null;
          this.constructionData = T_T.simpleDetect(
            formatFetchedData['Construction']
          )
            ? formatFetchedData['Construction']
            : null;
          this.householdSizeData = T_T.simpleDetect(
            formatFetchedData['HouseholdSize']
          )
            ? formatFetchedData['HouseholdSize']
            : null;
          this.educationData = T_T.simpleDetect(formatFetchedData['Education'])
            ? formatFetchedData['Education']
            : null;
          this.citizenshipData = T_T.simpleDetect(
            formatFetchedData['Citizenship']
          )
            ? formatFetchedData['Citizenship']
            : null;
          this.worklocationData = T_T.simpleDetect(
            formatFetchedData['WorkLocation']
          )
            ? formatFetchedData['WorkLocation']
            : null;
          this.workTransportationData = T_T.simpleDetect(
            formatFetchedData['WorkTransportation']
          )
            ? formatFetchedData['WorkTransportation']
            : null;
          this.dwellingData = T_T.simpleDetect(
            formatFetchedData['OccupiedDwellings']
          )
            ? formatFetchedData['OccupiedDwellings']
            : null;
          this.ownerData = T_T.simpleDetect(formatFetchedData['Ownership'])
            ? formatFetchedData['Ownership']
            : null;
          this.employmentData = T_T.simpleDetect(
            formatFetchedData['Employment']
          )
            ? formatFetchedData['Employment']
            : null;
          this.genderData = T_T.simpleDetect(formatFetchedData['Gender'])
            ? formatFetchedData['Gender']
            : null;
          if (this.genderData) {
            this.genderData =
              formatFetchedData['Gender'].Data.length > 1
                ? formatFetchedData['Gender']
                : null;
          }
          this.neighbourhoodData = {
            economicRegion: T_T.simpleDetect(
              formatFetchedData['EconomicRegion']
            )
              ? formatFetchedData['EconomicRegion']
              : null,
            province: T_T.simpleDetect(formatFetchedData['Province'])
              ? formatFetchedData['Province']
              : null,
            censusDivision: T_T.simpleDetect(
              formatFetchedData['CensusDivision']
            )
              ? formatFetchedData['CensusDivision']
              : null,
          };
          this.generalDataOne = T_T.simpleDetect(formatFetchedData['General'])
            ? formatFetchedData['General'].slice(0, 2)
            : null;
          this.generalDataTwo = T_T.simpleDetect(formatFetchedData['General'])
            ? formatFetchedData['General'].slice(2)
            : null;

          console.log('=========== ageData');

          // translate by google, wait untial locale inited
          // await T_T.delay(500);
          await this.beforeOptionGoogleTranslate();
          console.log('=========== beforeOptionGoogleTranslate');

          // options
          this.ageOptions = hybridShareCommunityAgeOptions(this.ageData);
          this.tongueOptions = hybridShareCommunityTongueOptions(
            this.tongueData
          );
          this.maritalOptions = hybridShareCommunityMaritalOptions(
            this.maritalData,
            this.$i18n.locale
          );
          this.incomeOptions = hybridShareCommunityIncomeOptions(
            this.incomeData
          );
          this.constructionOptions = hybridShareCommunityConstructionOptions(
            this.constructionData
          );
          this.householdSizeOptions = hybridShareCommunityHouseholdSizeOptions(
            this.householdSizeData
          );
          this.educationOptions = hybridShareCommunityEduOptions(
            this.educationData
          );
          this.citizenshipOptions = hybridShareCommunityCitizensOptions(
            this.citizenshipData
          );
          this.worklocationOptions = hybridShareCommunityWorklocationOptions(
            this.worklocationData
          );
          this.workTransportationOptions = hybridShareWorkTransOptions(
            this.workTransportationData
          );
          this.dwellingOptions = hybridShareCommunityDwellingsOptions(
            this.dwellingData
          );
          this.ownerOptions = hybridShareCommunityOwnershipOptions(
            this.ownerData
          );
          this.employmentOptions = hybridShareCommunityEmploymentOptions(
            this.employmentData
          );
          this.genderOptions = hybridShareCommunityGenderOptions(
            this.genderData
          );
          console.log('=========== hybridShareCommunityGenderOptions');

          // tag producer
          if (this.tongueOptions.max.length > 1) {
            this.tags.push(this.tongueOptions.first.title);
            this.tags.push(this.tongueOptions.sec.title);
          }

          console.log('=========== ageOptions');
          console.log(this.ageOptions);
        } catch (e) {}
      }
    } else {
      console.error('Invalid coordinates.');
    }
    this.$store.commit('appEndFetching');
  }

  public translate(str: string) {
    return HybridShareCommunityI18n.translate(str, this.$i18n.locale);
  }

  public async beforeOptionGoogleTranslate() {
    // translate raw Data
    let promises: Promise<any>[] = [];
    promises = promises.concat(this.dataGoogleTranslate(this.ageData));
    promises = promises.concat(this.dataGoogleTranslate(this.employmentData));
    promises = promises.concat(this.dataGoogleTranslate(this.dwellingData));
    promises = promises.concat(
      this.dataGoogleTranslate(this.workTransportationData)
    );
    promises = promises.concat(
      this.dataGoogleTranslate(this.householdSizeData)
    );
    promises = promises.concat(this.dataGoogleTranslate(this.incomeData));
    promises = promises.concat(this.dataGoogleTranslate(this.constructionData));
    promises = promises.concat(this.dataGoogleTranslate(this.tongueData));
    await Promise.all(promises);
    return;
  }

  // public async afterOptionsGoogleTranslate() {
  //     switch (this.$i18n.locale) {
  //         case I18N.EI18nLocale.Zn:
  //             this.employmentOptions.map(async (option: any) => {
  //                 option.title = await this.googleTransService.translate(option.title, 'zh-CN');
  //             });
  //             this.dwellingOptions.map(async (option: any) => {
  //                 option.title = await this.googleTransService.translate(option.title, 'zh-CN');
  //             });
  //             this.maritalOptions.rifoStory.title = await this.googleTransService.translate(this.maritalOptions.rifoStory.title, 'zh-CN');
  //             return;
  //         default:
  //             return;
  //     }
  // }

  public async googleTranslate(str: string): Promise<any> {
    try {
      switch (this.$i18n.locale) {
        case I18N.EI18nLocale.Zn:
          const translation = await this.googleTransService.translate(
            str,
            'zh-CN'
          );
          return translation;
        default:
          return str;
      }
    } catch (error) {
      console.error(error);
    }
  }

  public dataGoogleTranslate(data: any): Promise<any>[] {
    const promises: Promise<any>[] = [];
    data.Data.map((keyValue: any) => {
      const newPromiseFactory = async () => {
        keyValue['Key'] = await this.googleTranslate(keyValue['Key']);
        return keyValue['Key'];
      };
      promises.push(newPromiseFactory());
    });
    return promises;
  }

  public keysToCamel(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map((v: any) => this.keysToCamel(v));
    } else if (obj != null && obj.constructor === Object) {
      return Object.keys(obj).reduce(
        (result: any, key: any) => ({
          ...result,
          [_.upperFirst(key)]: this.keysToCamel(obj[key]),
        }),
        {}
      );
    }
    return obj;
  }
}
